import React, { Component } from "react"
import PropTypes from "prop-types"
import { Flex, Text } from "rebass"
import { teal900 } from "material-ui/styles/colors"
import IconButton from "material-ui/IconButton"
import ActionSave from "material-ui/svg-icons/content/save"
import ActionCopy from "material-ui/svg-icons/content/content-copy"
import ActionPaste from "material-ui/svg-icons/content/content-paste"
import AddIcon from "material-ui/svg-icons/content/add-circle"
import { Card, CardHeader, CardText } from "material-ui/Card"
import { DivHeaderActions } from "./styled"
import {
  defaultItemList,
  General,
  ItemCarousel,
} from "./components/carouselanimation"

const usedKeys = {}
const MULTIPLIER = Math.pow(2, 24)

function generateRandomKey() {
  let key
  while (
    key === undefined ||
    usedKeys.hasOwnProperty(key) ||
    !isNaN(Number(key))
  ) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32)
  }
  return key
}

class CarouselAnimationView extends Component {
  constructor(props) {
    super(props)
    const { container, list } = props.data.values
    let expandListArray = [list.length]
    for (let index = 0; index < expandListArray.length; index++) {
      expandListArray[index] = false
    }

    this.state = {
      container: container,
      list: list,
      expandGeneral: false,
      expandList: false,
      expandListArray: expandListArray,
    }
  }

  onAddItemList = () => {
    let newList = [
      ...this.state.list,
      { ...defaultItemList, id: generateRandomKey() },
    ]
    let newExpandList = [...this.state.expandListArray, false]
    this.setState({ list: newList, expandListArray: newExpandList })
  }
  handleCloseExpand = (index, expand) => {
    const newExpandList = this.state.expandListArray
    newExpandList[index] = expand
    this.setState({ expandListArray: newExpandList })
  }
  updateImage = (key, value, index) => {
    const itemList = this.state.list
    if (key === "url_image") {
      itemList[index].url_image = value
    } else if (key === "url_image_mobile") {
      itemList[index].url_image_mobile = value
    } else if (key === "url_bg") {
      itemList[index].url_bg = value
    } else if (key === "url_bg_mobile") {
      itemList[index].url_bg_mobile = value
    }

    this.setState({ list: itemList })
  }

  onSetValue = (key, value) => {
    this.setState({ ...this.state, [key]: value })
  }
  onToggle = (e, v) => {
    const container = this.state.container
    container["auto"] = v
    this.setState({ container: container })
  }
  onUpdateContainer = (key, value) => {
    const container = this.state.container
    if (key === "height") {
      container[key] = `${value}px`
    } else if (key === "paddingTopQuery0") {
      const pdtq = container.paddingTopQuery
      pdtq[0] = `${value}px`
      container["paddingTopQuery"] = pdtq
    } else if (key === "paddingTopQuery1") {
      const pdtq = container.paddingTopQuery
      pdtq[1] = `${value}px`
      container["paddingTopQuery"] = pdtq
    } else {
      container[key] = value
    }

    this.setState({ container: container })
  }
  onUpdateContainerType = (e, i, value) => {
    const container = this.state.container
    container["type"] = value
    this.setState({ container: container })
  }

  onClickCopy = () => {
    let newData = this.props.data
    newData.values.container = this.state.container
    newData.values.list = this.state.list
    localStorage.setItem(
      "CarouselAnimationView",
      JSON.stringify(newData.values)
    )
  }
  onClickPaste = () => {
    const carousel = JSON.parse(localStorage.getItem("CarouselAnimationView"))
    if (carousel && carousel !== null) {
      const { container, list } = carousel
      this.setState({
        container: container,
        list: list,
      })
    }
  }
  onClickSave = () => {
    let newData = this.props.data
    newData.values.container = this.state.container
    newData.values.list = this.state.list
    this.props.onUpdateData(newData)
  }

  onChangeText = (event, index) => {
    const itemList = this.state.list
    itemList[index].name = event.target.value
    this.setState({ list: itemList })
  }
  onSetItemValue = (key, value, index) => {
    const itemList = this.state.list
    const item = itemList[index]
    item[key] = value
    // itemList[index] = item

    this.setState({ list: itemList })
  }

  onUpdateBg = (key, value, index) => {
    const itemList = this.state.list
    const item = itemList[index]
    // item.bg[key] = value
    itemList[index] = {
      ...item,
      bg: { ...item.bg, [key]: value },
    }
    this.setState({ list: itemList })
  }

  onUpdatedImageAnimation = (key, value, index) => {
    const itemList = this.state.list
    const item = itemList[index]
    // item.image.animation[key] = value
    itemList[index] = {
      ...item,
      image: {
        ...item.image,
        animation: { ...item.image.animation, [key]: value },
      },
    }
    // itemList[index] = item
    // console.log(key, value)
    this.setState({ list: itemList })
  }

  onToggleChecked = (event, key, index) => {
    const itemList = this.state.list
    const item = itemList[index]
    // item.bg[key] = event.target.checked
    // itemList[index] = item
    itemList[index] = {
      ...item,
      bg: { ...item.bg, [key]: event.target.checked },
    }
    this.setState({ list: itemList })
  }
  onToggleAnimationChecked = (event, key, index) => {
    const itemList = this.state.list
    const item = itemList[index]
    // item.image[key] = event.target.checked
    // itemList[index] = item
    itemList[index] = {
      ...item,
      image: { ...item.image, [key]: event.target.checked },
    }
    this.setState({ list: itemList })
  }
  onPositionValue = (key, value, index) => {
    const itemList = this.state.list
    const item = itemList[index]
    itemList[index] = {
      ...item,
      position: { ...item.position, [key]: `${value}px` },
    }
    this.setState({ list: itemList })
  }

  onTitle = (key, value, index) => {
    const itemList = this.state.list
    const item = itemList[index]

    if (item && item.title) {
      itemList[index] = {
        ...item,
        title: { ...item.title, [key]: value },
      }
    }

    // console.log()
    this.setState({ list: itemList })
  }
  onSubTitle = (key, value, index) => {
    const itemList = this.state.list
    const item = itemList[index]
    if (item && item.subtitle) {
      itemList[index] = {
        ...item,
        subtitle: { ...item.subtitle, [key]: value },
      }
    }

    this.setState({ list: itemList })
  }

  render() {
    return (
      <div style={{ width: "100%" }}>
        <div style={{ overflowY: "scroll", height: 500 }}>
          <General
            state={this.state}
            onSetValue={this.onSetValue}
            onUpdateContainerType={this.onUpdateContainerType}
            onUpdateContainer={this.onUpdateContainer}
            onToggle={this.onToggle}
            styles={styles}
          />
          <Flex
            w={[1]}
            direction={"row"}
            justify={"space-between"}
            align={"center"}
            style={{ backgroundColor: teal900 }}
          >
            <Text pl={[2]} color={"white"}>
              List Carousel
            </Text>
            <IconButton
              onClick={this.onAddItemList.bind(this)}
              iconStyle={{ color: "#FFFFFF" }}
            >
              <AddIcon />
            </IconButton>
          </Flex>

          {this.state.list.map((item, index) => {
            // console.log(index, item)
            return (
              <div style={styles.paperCard} key={index}>
                <Card
                  expanded={this.state.expandListArray[index]}
                  onExpandChange={(expand) =>
                    this.handleCloseExpand(index, expand)
                  }
                >
                  <CardHeader
                    title={item.name}
                    actAsExpander={true}
                    showExpandableButton={true}
                    style={styles.headerCard}
                  />
                  <CardText expandable={true}>
                    <ItemCarousel
                      data={item}
                      list={this.state.list}
                      indexParent={index}
                      styles={styles}
                      updateImage={(value, key) =>
                        this.updateImage(key, value, index)
                      }
                      onChangeText={(e, indexParent) =>
                        this.onChangeText(e, indexParent)
                      }
                      onUpdateBg={(key, value, indexParent) =>
                        this.onUpdateBg(key, value, indexParent)
                      }
                      onToggleChecked={(e, key, indexParent) =>
                        this.onToggleChecked(e, key, indexParent)
                      }
                      onToggleAnimationChecked={(e, key, indexParent) =>
                        this.onToggleAnimationChecked(e, key, indexParent)
                      }
                      onUpdatedImageAnimation={(key, value, indexParent) =>
                        this.onUpdatedImageAnimation(key, value, indexParent)
                      }
                      onPositionValue={(key, value, indexParent) =>
                        this.onPositionValue(key, value, indexParent)
                      }
                      onTitle={(key, value) => this.onTitle(key, value, index)}
                      onSubTitle={(key, value) =>
                        this.onSubTitle(key, value, index)
                      }
                      onSetItemValue={(key, value, indexParent) =>
                        this.onSetItemValue(key, value, indexParent)
                      }
                    />
                  </CardText>
                </Card>
              </div>
            )
          })}
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    )
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10,
  },
  headerCard: {
    display: "flex",
    textAlign: "left",
  },
  paperCard: {
    margin: 10,
  },
  paperText: {
    padding: 10,
    marginBottom: 10,
  },
  customWidth: {
    width: 150,
  },
  block: {
    maxWidth: 250,
  },
  radioButton: {
    width: 136,
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto",
  },
}

CarouselAnimationView.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired,
}

CarouselAnimationView.defaultProps = {
  data: {},
}
export default CarouselAnimationView



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/CarouselAnimationView.js